const ApiUrls = {
  auth: {
    login: "smm/login.ms",
    logout: "smm/logout.ms",
    forgot_password: "smm/forgotpassword.ms",
    change_password: "smm/setpassword.ms",
    get_captcha: "smm/captcha.ms",
    check_captcha: "smm/checkcaptcha.ms"
  },
  commit: "smm/commit.ms",
  check_connection: "smm/conncheck.ms",
  dashboard: {
    setGraphConfig: "smm/saveuserconfig.ms",
    getGraphConfig: "smm/getuserconfig.ms"
  },
  domain: {
    add: "smm/adddomain.ms",
    edit: "smm/editdomain.ms",
    delete: "smm/deldomain.ms",
    list: "smm/listdomain.ms",
    uploadKeys: "smm/certmanual.ms",
    certSysData: "smm/certsys.ms",
    cleanCache: "smm/purge.ms",
    getBypass: "smm/listbypass.ms",
    setBypass: "smm/addbypass.ms"
  },
  ip_group: {
    add: "smm/addipgroup.ms",
    edit: "smm/editipgroup.ms",
    delete: "smm/delipgroup.ms",
    list: "smm/listipgroup.ms"
  },
  params: {
    get: "smm/getparams.ms" ,
    set: "smm/setparams.ms"
  },
  reports: {
    stats: "smm/getstats.ms",
    img: "smm/getimg.ms",
    graph: "smm/getgraphs.ms",
    statistic: "smm/report.ms",
    getGraph: "smm/getgraphsdata.ms"
  },
  site: {
    add: "smm/addsite.ms",
    edit: "smm/editsite.ms",
    delete: "smm/delsite.ms",
    list: "smm/listsite.ms",
    setCachedDomains: "smm/savesitenocachedids.ms"
  },
  user: {
    add: "smm/adduser.ms",
    edit: "smm/edituser.ms",
    delete: "smm/deluser.ms",
    list: "smm/listuser.ms",
    editDomains:"smm/userdomain.ms"
  }
};
export default ApiUrls;